export function getComingSoonOverlayMessage(
  isAutopostingToPlatform: boolean,
): string {
  return isAutopostingToPlatform
    ? 'We’ll auto-post your first video soon'
    : 'We’ll email your first video soon';
}
